import { JWT } from '../../../shared';
import {LOGOUT, LOGIN_SUCCESS, LOGIN_FAILED} from './constants';

const initialState = {
    isLoggedIn:JWT.isValidToken(),
    accessToken:JWT.getJwt(),
}

const authReducer = (state=initialState, action)=>{
       switch(action.type) {
           case LOGIN_SUCCESS:
               return {...state, isSubscribe:true, subscription:action.payload}
           case LOGIN_FAILED:{
               return {...state, isSubscribe:false, subscription:null}
           }
           case LOGOUT:{
            return {...state, isSubscribe:false, subscription:null}
           }
           
           default:
               return initialState;
       }
}

export default authReducer;
